import { ToneDto, ToneDtoImpl } from '../tonedto';

export interface GetTonePriceDetailsDto extends ToneDto
{
    getLanguageId(): string;
    getPackName(): string;
    getStatusCodes(): string;
    getStatusDesc(): string;
    getBPartyMsisdn(): string;
    getIsNewUser(): boolean;
}

export class GetTonePriceDetailsDtoImpl extends ToneDtoImpl implements GetTonePriceDetailsDto
{
    private languageId: string;
    private packName: string;
    private statusCodes: string;
    private statusDesc: string;
    private bPartyMsisdn: string;
    private isNewUser:boolean;

    getLanguageId(): string
    {
        return this.languageId;
    }
    setLanguageId(languageId: string)
    {
        this.languageId = languageId;
    }

    setPackName(packName: string)
    {
        this.packName = packName;
    }
    getPackName(): string
    {
        return this.packName;
    }
    getIsNewUser(): boolean
    {
        return this.isNewUser;
    }
    setIsNewUser(isNewUser: boolean)
    {
        this.isNewUser = isNewUser;
    }
    setStatusCodes(statusCodes: string)
    {
        this.statusCodes = statusCodes;
    }
    getStatusCodes(): string
    {
        return this.statusCodes;
    }

    getStatusDesc(): string
    {
        return this.statusDesc;
    }
    setStatusDesc(statusDesc: string)
    {
        this.statusDesc = statusDesc;
    }

    getBPartyMsisdn(): string
    {
        return this.bPartyMsisdn;
    }
    setBPartyMsisdn(bPartyMsisdn: string)
    {
        this.bPartyMsisdn = bPartyMsisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/gettoneprice/gettonepricedetailsdto.ts